export default "__VITE_ASSET__CtZSXPmW__";